import { resolveUserEmail } from "../auth/googleAuth";
import { resolveTierFromMembers } from "../api/sheets";
import { setFieldworkerMode, setSharedProject } from "./fieldworkerMode";

// Resolves which UI tier the signed-in user gets for a project and applies it via
// setFieldworkerMode (which dispatches an event so NavBar/App update live).
//
// Tiering rules — this is UI-gating for a trusted team, NOT a security boundary:
//  - The folder OWNER is always a manager (full UI).
//  - A NON-owner is a manager only if listed as "manager" in the project's Members tab;
//    otherwise they are a fieldworker (the safe default — also used on any failure).
export async function resolveAndApplyMode(opts: {
  spreadsheetId: string;
  ownedByMe: boolean;
}): Promise<"manager" | "fieldworker"> {
  // Record whether this is a joined (shared) project regardless of tier — resource
  // resolution depends on it (a non-owner manager still needs to Pick shared subfolders).
  setSharedProject(!opts.ownedByMe);
  if (opts.ownedByMe) {
    setFieldworkerMode(false);
    return "manager";
  }
  try {
    const email = await resolveUserEmail();
    const tier = await resolveTierFromMembers(opts.spreadsheetId, email);
    setFieldworkerMode(tier !== "manager");
    return tier;
  } catch (e) {
    console.warn("Tier resolution failed; defaulting to fieldworker:", e);
    setFieldworkerMode(true);
    return "fieldworker";
  }
}
